<div class="additional-doc-body">
  <div class="additional-doc-body-image">
    <p-fileUpload #fileUploader name="files"
                  [accept]="acceptedFiles"
                  [invalidFileTypeMessageSummary] = "invalidFileTypeMessage"
                  [invalidFileTypeMessageDetail] = "invalidFileTypeMessageDetail"
                  maxFileSize="maxFileSizeInBytes"
                  showUploadButton="false"
                  showCancelButton="false"
                  [chooseLabel]="chooseLabel"
                  multiple="multiple"
                  auto="false"
                  customUpload="true"
                  (uploadHandler)="uploadHandler($event)"
                  (onSelect)="onSelect($event)">
      <ng-template let-file pTemplate="file">
      </ng-template>
      <ng-template pTemplate="content">
        <div class="additional-doc-item-container">

          <div *ngIf="hasFiles() == false" class="drag-drop-files-instructions">
            <span>Additional documents?</span>
            <span>Drag and drop or add them here</span>
            <hr />
            <i class="fa fa-files-o fa-5x" aria-hidden="true"></i>
            <hr />
          </div>

            <mojo-additional-doc-item *ngFor="let file of files"
                                      (delete)="onDeleteFile($event)"
                                      [file]="file"></mojo-additional-doc-item>
        </div>
      </ng-template>
    </p-fileUpload>
  </div>
</div>
